import React, { FC } from 'react';

import FormFieldWrapper from '../Wrapper';
import { InputFormFieldProps } from './interfaces';
import { InputNumber } from 'antd';

const InputNumberFormField: FC<InputFormFieldProps> = ({
  name,
  label,
  help,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      label={label}
      help={help}
      render={fieldProps => <InputNumber {...props} {...fieldProps} />}
    />
  );
};

export default InputNumberFormField;
